import * as React from "react";
import { useTheme } from "styled-components";

import { MyIconProps } from "@ui/Assets/MyIcons/MyIcons";
import { TestWrapper } from "@ui/Atoms/TestWrapper";

import * as Styled from "./CalendarNotification.styled";

interface Props {
  testId?: string;
  className?: string;
  children: React.ReactNode;
  Icon: React.ComponentType<MyIconProps>;
}

const IconWithText = (props: Props): React.ReactElement => {
  const theme = useTheme();

  return (
    <TestWrapper testId={props.testId}>
      <Styled.TextIconContainer className={props.className}>
        <div>
          <props.Icon
            width={theme.icons.sizes.base_x4}
            color={theme.palette.grey600}
          />
        </div>

        <Styled.Text>{props.children}</Styled.Text>
      </Styled.TextIconContainer>
    </TestWrapper>
  );
};

export { IconWithText };
